import React, { useState, useContext, useRef, useEffect, MouseEventHandler } from 'react';
import { UserContext } from './UserContext';
import { PageContext } from './PageContext';
import { Window } from '@progress/kendo-react-dialogs';
import { ListView, ListViewHeader, ListViewFooter, ListViewItemProps } from '@progress/kendo-react-listview';
import { getUserNotifications } from '../services/apiService';
import { userNotification } from '../services/interfaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircle} from '@fortawesome/free-solid-svg-icons';
import { Typography } from '@progress/kendo-react-common';
import { SearchFields } from '../services/interfaces';
import { markUserNotificationsRead } from '../services/apiService';

interface Page {
    fields:string;
}


export function NotificationList(){
    const pageContext=useContext(PageContext);
    const userContext=useContext(UserContext);
    const notificationList = useRef<HTMLDivElement>(null);
    const [notificationLeft, setNotificationLeft]=useState(0);
    const toggleNotifications=()=>{
        pageContext?.setShowNotifications(!pageContext.showNotifications);
      }

    const getData=()=>{
        //console.log("Get notifications");
        getUserNotifications(userContext?.user.username).then(data => {
            console.log(data);
            pageContext?.setNotifications(data);
            //markUserNotificationsRead(userContext?.user.username);
        });
    }

    const setSearchFields=(item: any): MouseEventHandler<HTMLAnchorElement> => (event) => {
        console.log(item);
        let sfields = {
            archive:false,
            proofOnly:false,
            omitSpec:false,
            omitNewAd:false,
            adNum: item.element,
            status: [],
            statusMatch:"1",
            customer:"",
            account:"",
            salesRep:[],
            color:"",
            adType:"",
            section:[],
            team:[],
            size:"",
            colType:[],
            site:[],
            publication:[],
            whiteGlove:{text:"White Glove", value:""},
            tagline:"",
            dateType:{ text: "Any run date", value: "0" },
            fixedDate:{text:"", value:""},
            fixedDay:"",
            startDay:"",
            endDay:"",
            startDate:"",
            endDate:"",
            allGroup:false,
            groupName:"",
            queryName:"",
            queryIsGlobal:false,
            savedQueries:"",
            issue:""
        };
        pageContext?.setPage({...pageContext?.page,fields:JSON.stringify(sfields)});
        pageContext?.setSelectedTab(5);
    }

    const listItemRender=(props:ListViewItemProps)=>{
        let item=props.dataItem;
        let url = window.location.protocol + "//" + window.location.host + "?ad=" + item.element;
        var itemStyle = { backgroundColor: "none" }
        console.log(item.state);
        if (item.state =="0"){
            itemStyle = { backgroundColor: "var(--kendo-color-success-subtle-active)" }
        }else{
            itemStyle = { backgroundColor: "none" }
        }

        console.log(url)
        return(
            <div className='k-listview-item row p-2 border-bottom align-middle' style={itemStyle}>
                <div className='row'>
                    <div className='col-1'><Typography.p themeColor={item.type}><FontAwesomeIcon color={item.type} icon={faCircle}></FontAwesomeIcon></Typography.p></div>
                    <div className='col-4'>{item.origin}</div>
                    <div className='col'><a className="adLink" href={url}>{item.element}</a></div>
                </div>
                <div className='row'>
                    <div className='col'>{item.description}</div>
                </div>   
            </div>
        )
    }

    const handleOutsideClick = (event: MouseEvent) => { 
        var hte = event.target as HTMLElement;  
        console.log(hte)
        if (hte.className!="adLink"){
            pageContext?.setShowNotifications(false);
        }     
    }

    useEffect(()=>{
        if (pageContext?.showNotifications==true){
            markUserNotificationsRead(userContext?.user.username);
        }
    },[pageContext?.showNotifications])
    
    useEffect(() => {
        const left = window.innerWidth-350;
        setNotificationLeft(left);
        getData();
    }, []);

    return( 
        <>       
        {pageContext?.showNotifications? 
            <Window
                ref={notificationList}
                onClose={toggleNotifications} 
                height={600}
                width={300}   
                draggable={false}
                resizable={false}
                className='notificationList'
                top={60}
                left={notificationLeft}
                minimizeButton={undefined}
                maximizeButton={undefined}
            >
                <ListView
                    data={pageContext?.notifications}
                    item={listItemRender}
                />
            </Window>
        :null  }
        </>
    )
}